/* MATHO similares (Alice 2026-09-17, scripts/similares.py). Para quitarlo: --revertir.

   La fila de la ficha llega vacia y oculta. Este archivo pide las tarjetas a
   sections/matho-similares.liquid por la Section Rendering API, en orden:

     data-u1  /search?q=product_type:"<tipo de la ficha>"        el tipo exacto
     data-u2  /search?q=product_type:"<tipo>" OR ...             el grupo de tipos parecidos
     data-u3  /search?q=vendor:"<marca>"                         la misma marca
     data-u4  /collections/<respaldo>                            lo que traia la fila antes

   Pide la siguiente SOLO si con las anteriores no junto data-max tarjetas. Saca la ficha actual y los
   repetidos. Si no junta ninguna, la fila queda oculta (mejor nada que ocho productos que no pegan).

   Las consultas van con las cookies de la sesion, asi que el Liquid del otro lado ve al mismo cliente
   que la pagina: el precio de trade se arma igual que en /search.
*/
if (!customElements.get('matho-similares')) {
  class MathoSimilares extends HTMLElement {
    connectedCallback() {
      if (this.dataset.mathoListo) return;
      this.dataset.mathoListo = '1';
      this.resolver().catch(function (e) {
        console.warn('matho-similares:', e);
      });
    }

    direcciones() {
      var d = this.dataset;
      return [d.u1, d.u2, d.u3, d.u4].filter(function (u) {
        return u && u.length;
      });
    }

    async resolver() {
      var max = parseInt(this.dataset.max || '8', 10);
      if (!(max > 0)) max = 8;
      var vistos = new Set();
      if (this.dataset.handle) vistos.add(this.dataset.handle);
      var tarjetas = [];
      var direcciones = this.direcciones();

      for (var i = 0; i < direcciones.length; i++) {
        if (tarjetas.length >= max) break;
        var texto;
        try {
          var r = await fetch(direcciones[i], { credentials: 'same-origin' });
          if (!r.ok) continue;
          texto = await r.text();
        } catch (e) {
          continue;
        }
        var doc = new DOMParser().parseFromString(texto, 'text/html');
        var encontradas = doc.querySelectorAll('[data-matho-similares] > .swiper-slide');
        for (var j = 0; j < encontradas.length; j++) {
          var s = encontradas[j];
          var h = s.dataset.mathoHandle;
          if (!h || vistos.has(h)) continue;
          vistos.add(h);
          tarjetas.push(s);
          if (tarjetas.length >= max) break;
        }
      }

      if (!tarjetas.length) return;
      this.pintar(tarjetas.slice(0, max));
    }

    pintar(tarjetas) {
      var plantilla = this.querySelector('template[data-matho-plantilla]');
      if (!plantilla) return;
      var trozo = plantilla.content.cloneNode(true);

      var swiper = trozo.querySelector('swiper-component');
      if (swiper) {
        try {
          var opciones = JSON.parse(swiper.getAttribute('data-swiper-options') || '{}');
          opciones.slideCount = tarjetas.length;
          swiper.setAttribute('data-swiper-options', JSON.stringify(opciones));
        } catch (e) {
          /* si no se puede leer, queda el valor que trajo el Liquid */
        }
      }

      var caja = trozo.querySelector('.swiper-wrapper');
      if (!caja) return;
      tarjetas.forEach(function (s) {
        caja.appendChild(document.importNode(s, true));
      });

      /* destapar ANTES de colgar: el <swiper-component> se inicializa mirando si la seccion se ve */
      var seccion = this.closest('[data-section-id]');
      if (seccion) seccion.classList.remove('hidden');

      this.appendChild(trozo);
      plantilla.remove();
    }
  }

  customElements.define('matho-similares', MathoSimilares);
}
